::ng-deep particle-select-participants-step{display:flex;width:100%;height:100%}::ng-deep particle-select-participants-step .pos-relative{height:initial}
/*# sourceMappingURL=select-participants-step.component-ZUD5GZ56.css.map */
